import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Avatar,
  Box,
  IconButton,
} from "@mui/material";
import LocalPhoneTwoToneIcon from "@mui/icons-material/LocalPhoneTwoTone";
import EmailTwoToneIcon from "@mui/icons-material/EmailTwoTone";
import ErrorTwoToneIcon from "@mui/icons-material/ErrorTwoTone";
import LocationOnTwoToneIcon from "@mui/icons-material/LocationOnTwoTone";

function ProfileCard({ name, email, mobile, role, department }) {
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
        border: "1px solid #f0f0f0",
        overflow: "hidden",
      }}
    >
      {/* HEADER */}
      <CardContent
        sx={{
          background: "var(--thm-color)",
          textAlign: "center",
          py: 3,
        }}
      >
        <Avatar sx={{ width: 80, height: 80, mb: 1.5, mx: "auto" }}>
          {name?.[0]}
        </Avatar>

        <Typography variant="h6" sx={{ color: "#fff", fontWeight: 600 }}>
          {name}
        </Typography>

        <Typography sx={{ color: "#fff", opacity: 0.85, fontSize: 14 }}>
          {role}
        </Typography>

        {/* ACTION ICONS */}
        <Box sx={{ mt: 1.5 }}>
          <IconButton href={`tel:${mobile}`} sx={{ color: "#fff" }}>
            <LocalPhoneTwoToneIcon />
          </IconButton>
          <IconButton href={`mailto:${email}`} sx={{ color: "#fff" }}>
            <EmailTwoToneIcon />
          </IconButton>
        </Box>
      </CardContent>

      {/* DETAILS */}
      <CardContent sx={{ p: 3}}>
        <Typography
          sx={{
            fontWeight: 600,
            color: "#444",
            mb: 3,
            mt:1,
            fontSize: 15,
          }}
        >
          General Information
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2}}>
          <InfoItem label="Status" value="Active" icon={<ErrorTwoToneIcon />} />
          <InfoItem
            label="Phone Number"
            value={mobile}
            icon={<LocalPhoneTwoToneIcon />}
          />
          <InfoItem
            label="Email"
            value={email}
            icon={<EmailTwoToneIcon />}
          />
          <InfoItem
            label="Department"
            value={department}
            icon={<LocationOnTwoToneIcon />}
          />
        </Box>
      </CardContent>
    </Card>
  );
}

function InfoItem({ label, value, icon, isAddress = false }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: isAddress ? "flex-start" : "center",
        background: "#f9fafc",
        border: "1px solid #f0f0f0",
        borderRadius: 2,
        p: 1.1,
        px: 1.4,
      }}
    >
      {/* LEFT : ICON + LABEL */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          minWidth: 140,
        }}
      >
        {icon}
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 500,
            color: "#555",
          }}
        >
          {label}
        </Typography>
      </Box>

      {/* RIGHT : VALUE (Address Safe) */}
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: 600,
          color: "#222",
          maxWidth: "60%",
          textAlign: "right",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          lineHeight: 1.4,
        }}
      >
        {value || "-"}
      </Typography>
    </Box>
  );
}

export default ProfileCard;